<template>
  <div>
    <div
      v-show="!hasPermission(['elf_student'])"
      :class="{ show: canvasnav.overlay }"
      class="off-canvas off-canvas-overlay"
      style="left: -30px; z-index: 1035;"
    >
      <div class="off-canvas-body pd-25 tx-13">
        <!-- {{ canvasnav.module }} {{ obj.data.task.objectTypeId }} -->
        <ul class="sidebar-nav mg-b-25">
          <li v-if="canvasnav.module == 1" class="nav-label mg-b-10">
            Хуваалцах / Хүний нөөц удирдах
          </li>
          <li v-else-if="canvasnav.module == 2" class="nav-label mg-b-10">
            Тайлан
          </li>
          <template v-if="canvasnav.module == 1">
            <li class="nav-item">
              <a
                @click="
                  canvasnav.overlay = false;
                  showMention();
                "
                role="button"
                class="nav-link"
                ><feather type="users" class="ht-20-f wd-20-f mg-r-5"></feather
                >Хуваалцах</a
              >
            </li>
            <li class="nav-item">
              <a
                @click="
                  canvasnav.overlay = false;
                  projectUsers();
                "
                role="button"
                class="nav-link"
                ><feather
                  type="sliders"
                  class="ht-20-f wd-20-f mg-r-5"
                ></feather
                >Эрхийн тохиргоо</a
              >
            </li>
          </template>
          <template v-else-if="canvasnav.module == 2">
            <li v-if="obj.data.task.objectTypeId === 115" class="nav-item">
              <a @click="showCourseAnnual()" role="button" class="nav-link"
                ><feather type="users" class="ht-20-f wd-20-f mg-r-5"></feather
                >Сертификат / Шалгалт</a
              >
            </li>
            <li
              v-show="hasOneOf([obj.data.task.objectTypeId], [114, 613])"
              class="nav-item"
            >
              <a
                @click="exportUsers(obj.data.task)"
                role="button"
                class="nav-link"
                ><feather
                  type="clipboard"
                  class="ht-20-f wd-20-f mg-r-5"
                ></feather
                >Оролцогчдыг экспортлох</a
              >
            </li>
            <li
              v-show="hasOneOf([obj.data.task.objectTypeId], [115])"
              class="nav-item"
            >
              <a @click="printExamResult()" role="button" class="nav-link"
                ><feather
                  type="clipboard"
                  class="ht-20-f wd-20-f mg-r-5"
                ></feather
                >Үндсэн шалгалтын дүн татах</a
              >
            </li>
            <li
              v-show="hasOneOf([obj.data.task.objectTypeId], [616])"
              class="nav-item"
            >
              <a
                @click="lessonAnnualDataPrint(obj.data.task)"
                role="button"
                class="nav-link"
                ><feather
                  type="clipboard"
                  class="ht-20-f wd-20-f mg-r-5"
                ></feather
                >Шалгалтын дүн татах</a
              >
            </li>
            <li class="nav-item">
              <a @click="logViews(obj.data.task)" role="button" class="nav-link"
                ><feather
                  type="database"
                  class="ht-20-f wd-20-f mg-r-5"
                ></feather
                >Хандалтын түүх</a
              >
            </li>

            <template v-if="obj.data.task.objectTypeId === 115">
              <li class="nav-label mg-b-10 mg-t-25">Сургалтын систем</li>
              <li class="nav-item">
                <a
                  @click="
                    handleMainReportDialog({
                      key: 'd3f10267-b163-44bf-bb4b-e341746f1fde',
                      show: true,
                      propObj: { courseId: obj.data.task.id },
                    })
                  "
                  role="button"
                  class="nav-link"
                  ><feather
                    type="layers"
                    class="ht-20-f wd-20-f mg-r-5"
                  ></feather
                  >Сургалтын ерөнхий тайлан</a
                >
              </li>
              <li class="nav-item">
                <a
                  @click="
                    handleMainReportDialog({
                      key: 'b44390e2-e4e0-42de-8a3a-79002323591e',
                      show: true,
                      propObj: { courseId: obj.data.task.id },
                    })
                  "
                  role="button"
                  class="nav-link"
                  ><feather
                    type="layers"
                    class="ht-20-f wd-20-f mg-r-5"
                  ></feather
                  >Сургалтын хандалтын тайлан</a
                >
              </li>
            </template>
            <template v-if="obj.data.task.objectTypeId === 138">
              <li class="nav-label mg-b-10 mg-t-25">Сургалтын систем</li>
              <li class="nav-item">
                <a
                  @click="
                    handleMainReportDialog({
                      key: $store.state.app.activeGroup.id==9157?'learn_ReportByLearnerDetailed':'e044360a-0423-44e0-8bed-a04f0f259cac',
                      show: true,
                      propObj: { loginName: obj.data.task.loginName },
                    })
                  "
                  role="button"
                  class="nav-link"
                  ><feather
                    type="layers"
                    class="ht-20-f wd-20-f mg-r-5"
                  ></feather
                  >Ажилтны нэгдсэн тайлан</a
                >
              </li>
            </template>
          </template>
        </ul>
      </div>
    </div>
    <div
      @click="canvasnav.overlay = false"
      v-show="canvasnav.overlay"
      class="backdrop"
    ></div>

    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      @on-edit-close="editClosed"
      @on-task-posted="taskPosted"
      @on-attach="showFile"
    ></task-edit>
    <mention-users
      :show="projectMention.show"
      :obj.sync="obj.data.task"
      :module="projectMention.module"
      @on-force="$emit('on-task-detail', obj.data.task)"
      @on-mention-close="projectMention.show = false"
    ></mention-users>
    <user-permission
      :show="projectEdit.show"
      :obj.sync="obj.data.task"
      module="task"
      @on-edit-close="projectEdit.show = false"
      @on-share="showMention"
    ></user-permission>

    <assign-project
      :show="assignProject.show"
      :obj.sync="obj.data.task"
      :module="138"
      @on-assign-close="assnClosed"
      @on-assign-step1="obj.data.task.days = $event"
    ></assign-project>

    <b-modal
      v-model="completeProject.show"
      title="Төслийн үр дүн оруулах"
      hide-footer
    >
      <form @submit.prevent="completeProjectDo">
        <div class="form-group">
          <label for="formGroupExampleInput" class="d-block">Төлөв</label>
          <select class="form-control" v-model="completeProject.flag">
            <option :value="0" label="-- Сонгоно уу --"></option>
            <option :value="777" label="Шалгарсан"></option>
            <option :value="-777" label="Шалгараагүй"></option>
          </select>
        </div>
        <div class="form-group">
          <label for="formGroupExampleInput2" class="d-block"
            >Тайлбар бичнэ үү</label
          >
          <textarea
            class="form-control"
            placeholder="Тайлбар бичнэ үү"
            v-model="completeProject.desc"
          ></textarea>
        </div>
        <button class="btn btn-primary" type="submit">Үр дүнг хадгалах</button>
      </form>
    </b-modal>

    <b-modal v-model="qrIdObj.modal" title="QR" hide-footer>
      <div class="text-center d-flex align-items-center justify-content-center">
        <img
          class="wd-150 ht-150"
          :src="`data:image/png;base64, ${qrIdObj.img}`"
        />
      </div>
    </b-modal>

    <cancel-project
      :show="cancelProject.show"
      :obj.sync="obj.data.task"
      @on-assign-close="cancelProject.show = false"
    ></cancel-project>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      :boxId.sync="taskDialogSide.boxId"
      :parentTask="obj.data.task"
      @on-task-detail="showDetail"
      @on-task-reload="showDetailForce"
      @on-box-reload="boxReloadForce"
      @on-task-close="taskDialogSide.id = 0"
      @on-task-delete="taskDeleted($event)"
    ></task-detail-side>

    <examChart
      v-if="examChartObj.show"
      :id.sync="examChartObj.id"
      @on-task-close="
        examChartObj.id = 0;
        examChartObj.show = false;
      "
    ></examChart>

    <!-- v-if="mdlUserroleChange" -->
    <mdl-userrole-change
      :json.sync="mdlUserJSON"
      :isShow="mdlUserroleChange"
      @on-close="mdlUserroleChange = false"
    />
    <mdl-userpass-change
      :json.sync="mdlUserJSON"
      :isShow="mdlUserpassChange"
      @on-close="mdlUserpassChange = false"
    />

    <mdl-username-change
      :json.sync="mdlUserJSON"
      :isShow="mdlUsernameChange"
      @on-close="mdlUsernameChange = false"
    />

    <mdl-userstate-change
      :json.sync="mdlUserJSON"
      :isShow="mdlUserstateChange"
      @on-close="mdlUserstateChange = false"
    />

    <div
      class="content-header bd-b pd-0"
      v-show="!detailSetting.hideToolbar"
      ref="toolbar"
    >
      <nav
        ref="detailMainNav"
        class="navbar navbar-expand-lg wd-100p"
        style="height: 59px"
      >
        <menu-task
          :task.sync="obj.data.task"
          class="d-none"
          @on-menu-clicked="onMenuClicked"
        />
        <div v-if="!detailSetting.hideMainMenu" class="dropdown">
          <a
            class="order-1 navbar-brand tx-bold tx-spacing--2"
            href="javascript:void(0)"
            data-toggle="dropdown"
            style="max-width: 500px; overflow: hidden; text-overflow: ellipsis"
          >
            <button class="btn btn-xs btn-outline-primary btn-uppercase mg-t-5">
              <feather type="menu" class="wd-20-f ht-20-f mg-r-5"></feather>цэс
            </button>
          </a>
          <div class="dropdown-menu tx-13">
            <a
              @click="editShow(obj.data.task)"
              class="dropdown-item"
              role="button"
              >Засах</a
            >
            <a v-if="obj.data.task.objectTypeId === 625"
                @click="sendMessageNotif(obj.data.task.id)"
                class="dropdown-item"
                role="button"
                >Мессеж мэдэгдэл илгээх</a
              >

            <a v-if="obj.data.task.objectTypeId === 623"
                @click="resParlEvaluate(obj.data.task.id)"
                class="dropdown-item"
                role="button"
                >Үнэлгээ оруулах</a
              >
            <li>
              <hr class="dropdown-divider" />
            </li>
            <a
              v-if="
                obj.data.task.objectTypeId === 567 &&
                  !obj.data.task.isTender &&
                  hasPermission(['stf_proj_admin'])
              "
              @click="spAllowShinjeechRequest(obj.data.task)"
              class="dropdown-item bg-primary tx-white"
              role="button"
              >Хүсэлтийг зөвшөөрөх</a
            >

            <a
              @click="
                canvasnav.module = 1;
                canvasnav.overlay = true;
              "
              class="dropdown-item d-flex"
              role="button"
            >
              Хуваалцах / Хүний нөөц удирдах
              <feather
                class="mg-l-auto text-muted"
                type="chevron-right"
              ></feather>
            </a>

            

            <div
              v-if="
                obj.data.task.objectTypeId === 138 &&
                  hasOneOf(['hradmin'], $store.state.user.access)
              "
            >
              <li>
                <hr class="dropdown-divider" />
              </li>
              <a
                @click="userSettingsClicked(5, obj.data.task)"
                class="dropdown-item"
                role="button"
                >Цэсний тохиргоо</a
              >
              <a
                @click="userSettingsClicked(4, obj.data.task)"
                class="dropdown-item"
                role="button"
                >Нууц үг солих</a
              >
              <a
                @click="userSettingsClicked(1, obj.data.task)"
                class="dropdown-item"
                role="button"
                >Нэвтрэх нэр солих</a
              >
              <a
                @click="userSettingsClicked(7, obj.data.task)"
                class="dropdown-item"
                role="button"
                >Хэрэглэгчийн төлөв солих</a
              >
              <!-- <a
                @click="
                  handleMainReportDialog({
                    key: 'learn_userReport',
                    show: true,
                    propObj: { loginName: obj.data.task.loginName },
                  })
                "
                class="dropdown-item"
                role="button"
                >Тайлан=>Сургалтын систем=>Ажилтны тайлан</a
              > -->
            </div>

            <div
              v-if="
                obj.data.task.objectTypeId === 569 &&
                  hasOneOf(['hradmin'], $store.state.user.access)
              "
            >
              <li>
                <hr class="dropdown-divider" />
              </li>
              <a
                @click="
                  handleMainReportDialog({
                    key: 'elf_7',
                    show: true,
                    propObj: {
                      tid: obj.data.task.organizationTaskId,
                      userId: obj.data.task.secondOrganizationTaskId,
                    },
                  })
                "
                class="dropdown-item"
                role="button"
                >Тайлан=>Тэтгэлгийн систем=>Тооцоо нийлсэн акт</a
              >
            </div>

            <template
              v-if="
                (!detailMenuSetting.hideEmail &&
                  obj.data.task.objectTypeId === 115) ||
                  (obj.data.task.objectTypeId === 500 &&
                    hasOneOf(
                      ['learningadmin', 'learningteacher'],
                      $store.state.user.access
                    )) ||
                  (obj.data.task.objectTypeId === 561 &&
                    hasOneOf(['admin'], $store.state.user.access))
              "
            >
              <a @click="sendIcsMail()" class="dropdown-item" role="button"
                >И-мэйл мэдэгдэл илгээх
                <template v-if="obj.data.task.objectTypeId != 561"
                  >/календарь файл/</template
                ></a
              >
            </template>
            <template v-if="hasOneOf(['messenger'], $store.state.user.access)">
              <a @click="shareToMessenger()" class="dropdown-item" role="button"
                >Мессенжерт хавсралт болгож илгээх</a
              >
            </template>
            <template
              v-if="
                obj.data.task.objectTypeId === 529 &&
                  hasOneOf(
                    ['learningadmin', 'learningteacher'],
                    $store.state.user.access
                  )
              "
            >
              <li>
                <hr class="dropdown-divider" />
              </li>
              <a @click="showMembers()" class="dropdown-item" role="button"
                >Гишүүн удирдах</a
              >
              <a @click="mailerLite(1)" class="dropdown-item" role="button"
                >И-мэйл campaign үүсгэх</a
              >
              <a @click="mailerLite(2)" class="dropdown-item" role="button"
                >И-мэйл илгээх</a
              >
              <li>
                <hr class="dropdown-divider" />
              </li>
            </template>
            <template
              v-if="
                obj.data.task.objectTypeId === 115 &&
                  hasOneOf(
                    ['learningadmin', 'learningteacher'],
                    $store.state.user.access
                  )
              "
            >
              <!-- <a @click="copyCourseLink()" class="dropdown-item" role="button"
                >Сургалтын үзэх холбоос</a
              > -->
              <!-- <a
                @click="prepareExamResult()"
                class="dropdown-item"
                role="button"
                >Шалгалтын дүн боловсруулах</a
              > -->
              <!-- <a @click="printExamResult()" class="dropdown-item" role="button"
                >Шалгалтын дүн татах</a
              > -->
              <!-- <a
                @click="renewAllCourseCertificate()"
                class="dropdown-item"
                role="button"
                >Сертификат шинэчлэх</a
              > -->

              <a @click="showMembers()" class="dropdown-item" role="button"
                >Элсэлт удирдах</a
              >
              <li>
                <hr class="dropdown-divider" />
              </li>
              <template
                v-if="
                  $store.state.app.activeGroup.id == 100 &&
                  obj.data.task.objectTypeId == 115
                "
              >
                <a @click="sendTaisInfo(1)" class="dropdown-item" role="button"
                  >TAIS мэдээ илгээх</a
                >
                <a @click="sendTaisInfo(3)" class="dropdown-item" role="button"
                  >TAIS мэдэгдэл илгээх</a
                >
                <li>
                  <hr class="dropdown-divider" />
                </li>
              </template>

              <a
                @click="duplicateCourse(obj.data.task)"
                class="dropdown-item"
                role="button"
                >Хуулбар үүсгэх</a
              >
              <a
                @click="crseRpr(obj.data.task)"
                class="dropdown-item"
                role="button"
              >
                Ирцийн мэдээлэл шинэчлэх
              </a>
              <!-- <a
                v-if="$store.state.app.activeGroup.id == 9259"
                @click="
                  handleMainReportDialog({
                    key: 'lessonAttendanceReport',
                    show: true,
                    propObj: { courseId: obj.data.task.id },
                  })
                "
                class="dropdown-item"
                role="button"
                >Тайлан=>Сургалтын систем=>Ирцийн тайлан</a
              > -->
            </template>

            <template
              v-else-if="
                obj.data.task.objectTypeId === 181 ||
                  obj.data.task.objectTypeId === 270 ||
                  obj.data.task.objectTypeId === 340 ||
                  obj.data.task.objectTypeId === 341 ||
                  obj.data.task.objectTypeId === 285 ||
                  obj.data.task.objectTypeId === 361
              "
            >
              <!-- цахим ном -->
              <a @click="showMembers()" class="dropdown-item" role="button"
                >Гишүүн удирдах</a
              >
            </template>
            <template v-if="obj.data.task.objectTypeId === 341">
              <a @click="fetchExamResult()" class="dropdown-item" role="button"
                >Цахим шалгалтын дүн татах</a>
            </template>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <a
              @click="
                canvasnav.module = 2;
                canvasnav.overlay = true;
              "
              class="dropdown-item d-flex"
              role="button"
            >
              Тайлан
              <feather
                class="mg-l-auto text-muted"
                type="chevron-right"
              ></feather>
            </a>

            <!-- <template v-if="obj.data.task.objectTypeId==525 && hasOneOf(['learningadmin', 'learningteacher'], $store.state.user.access)">
              <a @click="showAttendence(obj.data.task)" class="dropdown-item" role="button">Ирц бүртгэх</a>
            </template> -->
            <!-- <a
              @click="logViews(obj.data.task)"
              class="dropdown-item"
              role="button"
              >Хандалтын түүх</a
            > -->

            <!-- <a
              @click="exportUsers(obj.data.task)"
              class="dropdown-item"
              role="button"
              >{{obj.data.task.objectTypeId === 115?'Сургалтын тайлан':'Оролцогчдыг экспортлох'}}</a
            > -->

            <a
              v-if="
                obj.data.task.objectTypeId === 114 &&
                  obj.data.task.isPublic &&
                  obj.data.task.isRepeat
              "
              @click="attendanceQR(obj.data.task)"
              class="dropdown-item"
              role="button"
            >
              Ирц бүртгэх QR
            </a>

            <a
              v-if="obj.data.task.objectTypeId === 396"
              @click="teacherReportData(obj.data.task)"
              class="dropdown-item"
              role="button"
            >
              Үнэлгээний тайлан
            </a>
            <li v-if="obj.data.task.objectTypeId === 561">
              <hr class="dropdown-divider" />
            </li>
            <template
              v-if="obj.data.task.objectTypeId === 561 && obj.data.task.i8 >= 0"
            >
              <template
                v-if="
                  obj.data.task.organizationTask.locTypeId == 251286 ||
                    obj.data.task.organizationTask.locTypeId == 162068
                "
              >
                <a
                  v-if="obj.data.task.i8 == 2"
                  @click="projStfAssign(obj.data.task)"
                  class="dropdown-item"
                  role="button"
                >
                  <span v-if="obj.data.task.days == 1">Шинжээч томилох</span>
                  <span v-else-if="obj.data.task.days == 2"
                    >Шинжээчдийн бүрэлдэхүүн</span
                  >
                  <span v-else>Судлаачдын сан тохируулах</span>
                </a>
                <!-- end bnu -->
              </template>
              <a
                v-else
                @click="projStfAssign(obj.data.task)"
                class="dropdown-item"
                role="button"
              >
                <!-- {{ obj.data.task.days }} -->
                <span v-if="obj.data.task.days == 1">Шинжээч томилох</span>
                <span v-else-if="obj.data.task.days == 2"
                  >Шинжээчдийн бүрэлдэхүүн</span
                >
                <span v-else>Судлаачдын сан тохируулах</span>
              </a>
              <a
                v-if="obj.data.task.i8 == 1"
                class="dropdown-item"
                role="button"
                >Буцаах</a
              >
              <a
                @click="projStfComplete(obj.data.task)"
                v-if="obj.data.task.i8 == 2"
                class="dropdown-item"
                role="button"
                >Үр дүн оруулах</a
              >

              <a
                @click="projStfRemovedShinjeechid(obj.data.task)"
                v-if="obj.data.task.i8 > 1"
                class="dropdown-item"
                role="button"
                >Хасагдсан шижээчид</a
              >

              <li>
                <hr class="dropdown-divider" />
              </li>
              <a
                @click="cancelShow(obj.data.task)"
                v-if="obj.data.task.isCompleted"
                style="color: orange"
                class="dropdown-item"
                role="button"
                >Цуцлах</a
              >
            </template>
            <li v-if="obj.data.task.objectTypeId === 601">
              <hr class="dropdown-divider" />
            </li>
            <a
              v-if="obj.data.task.objectTypeId === 601"
              @click="dzStfDownloadMembers(obj.data.task)"
              class="dropdown-item"
              role="button"
            >
              Шалгаруулалтын мэдээлэл татах
            </a>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <a
              v-if="obj.data.task.objectTypeId === 506"
              @click="genQr(obj.data.task)"
              class="dropdown-item"
              role="button"
            >
              QR хэвлэх
            </a>

            <a
              v-if="$store.state.app.activeGroup.id == 9157 && obj.data.task.objectTypeId == 340"
                @click="examScorePlan(obj.data.task)"
                class="dropdown-item"
                role="button"
                >Дүнгийн хавтгай</a
              >

            <a
              @click="deleteShow(obj.data.task)"
              class="dropdown-item"
              style="color: red"
              role="button"
              >Устгах</a
            >
          </div>
        </div>

        <div v-if="detailSetting.showMiniMenu" class="btn-group mg-r-10">
          <button
            @click="editShow(obj.data.task)"
            class="btn btn-xs btn-outline-primary btn-uppercase mg-t-5"
          >
            <feather type="edit" class="wd-20-f ht-20-f mg-r-5"></feather>Засах
          </button>
          <button
            @click="deleteShow(obj.data.task)"
            class="btn btn-xs btn-outline-danger btn-uppercase mg-t-5"
          >
            <feather type="trash-2" class="wd-20-f ht-20-f mg-r-5"></feather
            >Устгах
          </button>
        </div>

        <a v-if="obj.data.task.objectTypeId === 623"
                @click="resParlEvaluate(obj.data.task.id)"
                class="btn btn-success btn-xs"
                role="button"
                >Үнэлгээ оруулах</a
              >

        <button
          @click="visibleChanged(false)"
          class="order-2 navbar-toggler"
          type="button"
        >
          <feather type="x" class="wd-20 ht-20 text-danger"></feather>
        </button>
        <div class="bd-l pd-l-10" v-show="obj.data.task.task !='гарчиггүй'">{{ obj.data.task.task }}</div>

        <div
          class="order-2 collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <div
            v-show="!hasPermission(['elf_student'])"
            class="mg-l-auto"
            v-if="!hideMentionUsers"
          >
            <!-- TODO: ene hooson tsonh garj ireed bsn uchir tur avav erhiin tohirgoo ogohdoo doorh moriig task-users d oruulj ogno -->
            <!--  -->
            <task-users
              v-if="fetched"
              :taskId="obj.data.task.id"
              @on-task-users="onTaskUsers"
              @on-setting="projectUsers()"
            >
              <a
                @click="showMention()"
                slot="mention"
                class="btn btn-xs btn-icon btn-primary"
              >
                <span>
                  <b-icon class="tx-white" icon="person-plus"></b-icon>
                </span>
              </a>
            </task-users>
          </div>
          <task-actions
            v-if="fetched"
            @on-transfer="openOrAssignColumn(id, $event)"
            :task.sync="obj.data.task"
            :transferOptions="transferOptions"
            class="mg-l-50"
          ></task-actions>

          <!-- <button
            @click="changeTaskDone"
            :class="`btn mg-l-20 btn-${
              obj.data.task.im.doneFlag == 2 ? 'success' : 'warning'
            } btn-xs`"
            v-if="
              obj.data.task.im != null &&
              obj.data.task.im.pinIs &&
              !obj.data.task.isCompleted &&
              obj.data.task.column != null
            "
          >
            <feather
              :type="obj.data.task.im.doneFlag == 2 ? 'check-square' : 'square'"
              class="wd-16 ht-16 mg-r-5"
            ></feather>
            {{ obj.data.task.im.doneFlag == 2 ? "Шалгасан" : "Шалгасан" }}
          </button> -->

          <button
            v-show="checkChatAvailableOts(obj.data.task.objectTypeId)"
            @click="openChat()"
            role="button"
            class="mg-l-auto btn btn-sm btn-icon btn-primary btn-uppercase"
            v-if="hasPermission(['messenger'])"
          >
            <feather type="message-square" class="mg-r-5"></feather> Чат
          </button>

          <button
            class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
            @click="visibleChanged(false)"
          >
            <feather type="x" class="mg-r-5"></feather>Хаах
          </button>
        </div>
      </nav>
      
    </div>
    <p v-if="!fetched"></p>
    <div v-else class="content-body pd-x-0 pd-y-0">
      <!-- <forumDetail v-if="obj.data.task.objectTypeId==124" :obj="obj.data"></forumDetail>
      <forumTopicDetail v-else-if="obj.data.task.objectTypeId==125" :obj="obj.data"></forumTopicDetail>-->
      <!-- ene -->
      <youtubeDetail v-if="obj.data.task.objectTypeId == 122" :obj="obj.data" />
      <task-loader
        :ref="`bx_${b.id}`"
        v-else-if="hasOneOf([451], [obj.data.task.objectTypeId])"
        :ot="obj.data.task.objectTypeId"
        :obj="obj"
        :fields="fields"
        @on-show-file="showFile"
        @show-edit="editShow($event)"
        @on-detail="showDetail"
        @on-reload="$emit('on-task-reload', $event)"
        @load-box="loadBoxData"
      />

      <div
        v-else
        class="detail-wrapper detail-large"
        :style="`${detailSetting.hideToolbar ? 'top:0px' : ''}`"
        :class="{
          minimize: $store.state.app.aside.minimize,
          maximize: $store.state.app.aside.maximize,
        }"
      >
        <div class="detail-sidebar">
          <div class="detail-sidebar-header">
            <b-icon icon="search" class="mg-r-5"></b-icon>
            <div class="search-form">
              <input type="search" class="form-control" placeholder="Хайх" />
            </div>
            <a
              href="#modalNewContact"
              class="btn btn-xs btn-icon btn-primary"
              data-toggle="modal"
            >
              <span
                data-toggle="tooltip"
                title
                data-original-title="Add New Contact"
              >
                <feather type="plus-square"></feather>шинэ
              </span>
            </a>
          </div>
          <vue-custom-scrollbar
            class="detail-sidebar-body"
            :style="`height:calc(100vh - 105px)`"
            :settings="{ maxScrollbarLength: 60 }"
          >
            <div class="tab-content">
              <div class="tab-pane fade active show">
                <div class="pd-y-20 pd-x-10 detail-list">
                  <label class="detail-list-divider">Бүрдэл</label>

                  <div
                    @click="loadBoxData(b)"
                    class="media"
                    role="button"
                    v-for="(b, i) in obj.data.task.b"
                    :key="i"
                    :class="{ active: b.id == activeBox.id }"
                  >
                    <div class="avatar avatar-sm avatar-offline">
                      <span class="avatar-initial rounded-circle">{{
                        b.nm.charAt(0)
                      }}</span>
                    </div>
                    <div class="media-body mg-l-10">
                      <h6 class="tx-13 mg-b-3">{{ b.nm }}</h6>
                      <span class="tx-12">{{ boxItemCount(b) }}</span>
                    </div>
                    <nav>
                      <a href>
                        <b-icon icon="pencil"></b-icon>
                      </a>
                      <a href>
                        <b-icon icon="trash"></b-icon>
                      </a>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </vue-custom-scrollbar>
        </div>
        <div
          :class="
            `detail-content ${$store.state.app.isMobile ? 'vsble-on-mble' : ''}`
          "
        >
          <div v-if="obj.data.task.objectTypeId == 525">
            <course-attendence :propId="obj.data.task.id"></course-attendence>
          </div>
          <div :class="`d-flex`" v-else>
            <div
              :class="
                `overflow-auto go-boxes ${
                  (boxMenuCount == 0 && activeBox.id == 0) ||
                  detailSetting.leftSideHide
                    ? 'd-none'
                    : 'wd-20p bd-r'
                }`
              "
              :style="`height: ${detailSetting.leftSideHeight}px`"
            >
              <boxes
                ref="detailBoxes"
                @on-attach="showFile"
                @on-load-box="loadBoxData"
                @on-reload="onBoxReload($event)"
                @on-box-menu-loaded="boxMenuCount = $event"
                :obj.sync="obj"
                :activeBox="activeBox"
                :detailSettingProp="detailSetting"
                @box-delete="deleteBoxConfirm"
              />
            </div>
            <div
              :class="
                `go-main ${
                  (boxMenuCount == 0 && activeBox.id == 0) ||
                  detailSetting.leftSideHide
                    ? 'wd-100p pos-relative'
                    : 'wd-80p pos-relative'
                }`
              "
            >
              <div>
                <div :class="`d-flex`">
                  <div
                    :class="
                      `${
                        activeBox.id != 0
                          ? detailSetting.hideRightSidebar
                            ? 'wd-100p'
                            : 'wd-65p'
                          : 'd-none'
                      }`
                    "
                  >
                    <b-overlay :show="boxLoading" rounded="sm">
                      <template v-if="activeBox.id == 0">
                        <div
                          class="container d-flex justify-content-center ht-90p"
                        >
                          <div
                            class=" mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                          >
                            <div class="wd-80p wd-sm-300 mg-b-15">
                              <img
                                src="assets/svg/boxempty.svg"
                                alt
                                class="img-fluid"
                              />
                            </div>
                            <h4 class="tx-20 tx-sm-24 text-muted"></h4>
                            <p class="tx-color-03 mg-b-30 tx-center">
                              Бүрдэл сонгоогүй байна
                            </p>
                          </div>
                        </div>
                      </template>
                      <template v-else v-for="(b, i) in obj.data.task.b">
                        <loader
                          :ref="`box_${b.id}`"
                          :key="`b_${i}`"
                          :detailSettingProp="detailSetting"
                          :box="b"
                          :parentTask="obj.data.task"
                          :obj="obj"
                          :activeBox="activeBox"
                          :prms="{ boxChooser: false }"
                          v-if="b.id == activeBox.id"
                          @show-edit="editShow($event)"
                          @box-edit="editBox"
                          @box-delete="deleteBoxConfirm"
                          @on-detail="showDetail"
                          @on-attach="showFile($event)"
                          @load-box="loadBoxData"
                          @update-box-count="
                            b.attachCount = $event.count;
                            b.formCount = $event.count;
                          "
                          @box-loaded="boxLoading = false"
                          @on-reload-parent="init($event)"
                          @on-exam-report="onExamReport"
                          @on-exam-report-export="onExamReportExport"
                          @on-form-setting="onFormSeting"
                          @set-fullTask="setFullTask"
                          @on-prepare-exam-eesult="prepareExamResult"
                          @on-print-exam-result="printExamResult"
                        />
                      </template>
                    </b-overlay>
                  </div>
                  <div
                    v-show="!detailSetting.hideRightSidebar"
                    :class="`${activeBox.id == 0 ? 'wd-100p' : 'wd-35p bd-l'}`"
                  >
                    <ul
                      ref="detailNavTab"
                      id="detailNavTabId"
                      class="bg-white detail-nav nav nav-line nav-fill pd-x-20"
                    >
                      <li class="nav-item">
                        <a
                          alt="Дэлгэрэнгүй мэдээлэл"
                          title="Дэлгэрэнгүй мэдээлэл"
                          @click="changeTab(1)"
                          role="button"
                          class="nav-link"
                          :class="{ active: activeTab.ind == 1 }"
                        >
                          <feather type="menu"></feather>
                          <span
                            v-if="
                              obj.data.task.objectTypeId == 115 ||
                                obj.data.task.objectTypeId == 114
                            "
                          >
                            Дэлгэрэнгүй мэдээлэл
                          </span>
                        </a>
                        <!-- Дэлгэрэнгүй мэдээлэл -->
                        <!-- <feather type="menu"></feather> -->
                        <!-- </a> -->
                      </li>
                      <li
                        class="nav-item"
                        v-show="!detailSetting.hideExecution"
                      >
                        <a
                          alt="Тэмдэглэл"
                          title="Тэмдэглэл"
                          @click="changeTab(2)"
                          role="button"
                          class="nav-link"
                          :class="{ active: activeTab.ind == 2 }"
                        >
                          <feather type="clipboard"></feather>
                        </a>
                      </li>
                      <li class="nav-item" v-show="!detailSetting.hideProcess">
                        <a
                          alt="Гүйцэтгэл"
                          title="Гүйцэтгэл"
                          @click="changeTab(3)"
                          role="button"
                          class="nav-link"
                          :class="{ active: activeTab.ind == 3 }"
                        >
                          <feather type="activity"></feather>
                        </a>
                      </li>
                      <li class="nav-item" v-show="!detailSetting.hideMembers">
                        <a
                          alt="Оролцогчид"
                          title="Оролцогчид"
                          @click="changeTab(4)"
                          role="button"
                          class="nav-link"
                          :class="{ active: activeTab.ind == 4 }"
                        >
                          <!-- Оролцогчид -->
                          <feather type="users"></feather>
                        </a>
                      </li>
                    </ul>
                    <!-- :style="`height:calc(100vh - 169px)`" -->
                    <vue-custom-scrollbar
                      v-if="activeTab.ind == 1"
                      :style="`height: ${scrHeight.execution - 55}px`"
                      class="pd-y-20 pd-x-40"
                      :settings="{ maxScrollbarLength: 60 }"
                    >
                      <div>
                        <template
                          v-if="
                            obj.data.task.objectTypeId === 115 &&
                              hasOneOf(
                                ['learningadmin', 'learningteacher'],
                                $store.state.user.access
                              )
                          "
                        >
                          <input
                            style="width: 1px; height: 1px; position: absolute; left: -1px; top: -1px; "
                            v-on:focus="$event.target.select()"
                            readonly
                            value="343100195073"
                            ref="courseLink"
                          />

                          <a
                            @click="copyCourseLink()"
                            class="btn btn-outline-primary btn-xs btn-block mg-b-20"
                            role="button"
                            >Сургалтын үзэх холбоос</a
                          >
                        </template>

                        <course-info
                          v-if="obj.data.task.objectTypeId == 115"
                          :fields="fields"
                          :obj="obj"
                          :loaded="fetched"
                          :boxId="boxId"
                          :parentTask="parentTask"
                        />
                        <task-info
                          v-else
                          :fields="fields"
                          :obj="obj"
                          :loaded="fetched"
                          :boxId="boxId"
                          :parentTask="parentTask"
                          @on-task-detail="$emit('on-task-detail', $event)"
                          @on-show-value="onShowValue"
                          @on-reload="$emit('on-task-reload', $event)"
                          @on-task-field-set-local="
                            obj.data.task[$event.fieldName] = $event.value
                          "
                          @ebarimt-return="ebarimtReturn"
                          @ebarimt-print="ebarimtPrint"
                          @on-attach="showFile"
                        />
                      </div>
                    </vue-custom-scrollbar>
                    <template v-else-if="activeTab.ind == 2">
                      <div
                        ref="executionListOuter"
                        id="executions-outer"
                        class="overflow-auto pd-10"
                        :style="`height: ${scrHeight.execution - 55}px`"
                      >
                        <execution-list
                          ref="executionList"
                          :taskId="obj.data.task.id"
                          @on-reach-bottom="onReachBottom"
                          @on-attach="showFile"
                        ></execution-list>
                      </div>

                      <execution-reply
                        ref="executionReply"
                        @on-height="
                          scrHeight.executionReply = $event;
                          getWindowHeight();
                        "
                        :taskId="obj.data.task.id"
                        @on-posted="executionInit"
                        class="bd-t"
                      ></execution-reply>
                    </template>
                    <template v-else-if="activeTab.ind == 3">
                      <div class="row no-gutters">
                        <vue-custom-scrollbar
                          class="col-7 bd-r"
                          :style="`height: ${scrHeight.execution - 55}px`"
                        >
                          <transfers
                            :task="obj.data.task"
                            @on-transfers-loaded="obj.data.transfers = $event"
                          />
                        </vue-custom-scrollbar>
                        <vue-custom-scrollbar class="col-5">
                          <task-process
                            :task="obj.data.task"
                            :columns="obj.data.columns"
                            :users="obj.data.pinnedUsers"
                            :transfers.sync="obj.data.transfers"
                            class="pd-10"
                          ></task-process>
                        </vue-custom-scrollbar>
                      </div>
                    </template>
                    <template v-else-if="activeTab.ind == 4">
                      <div class="row no-gutters">
                        <vue-custom-scrollbar
                          class="col-12 bd-r"
                          :style="`height: ${scrHeight.execution - 55}px`"
                        >
                          <task-users-pinned :taskId="id" :objectTypeId="obj.data.task.objectTypeId" />
                          <!-- <transfers
                            :task="obj.data.task"
                            @on-transfers-loaded="obj.data.transfers = $event"
                          /> -->
                        </vue-custom-scrollbar>
                      </div>
                    </template>
                  </div>
                </div>

                <div
                  ref="goTaskFooter"
                  id="goTaskFooterId"
                  class="bg-gray-200 go-task-footer d-flex align-items-center bd-t pd-x-20 ht-55"
                >
                  <div class="d-flex justify-content-between wd-100p">
                    <div class="d-flex align-items-center">
                      №: {{ obj.data.task.id }}
                    </div>
                    <div
                      v-if="obj.data.task.user != null"
                      class="d-flex align-items-center"
                      @click="handleUserInfoModal(obj.data.task.user.id)"
                      role="button"
                    >
                      <img
                        :src="obj.data.task.user.avator"
                        class="wd-30 rounded-circle mg-r-15"
                        alt
                      />
                      <div>
                        <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                          {{ obj.data.task.user.fullName }}
                        </h6>
                        <span class="d-block tx-11 text-muted">{{
                          obj.data.task.user.position
                        }}</span>
                      </div>
                    </div>
                    <div class="wd-30p" v-if="obj.data.task.column != null">
                      <div class="progress ht-30">
                        <div
                          class="progress-bar bg-info"
                          role="progressbar"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          :style="{
                            width:
                              (100 *
                                obj.data.columns
                                  .map(function(el) {
                                    return el.id;
                                  })
                                  .indexOf(obj.data.task.column.id)) /
                                obj.data.columns.length +
                              '%',
                          }"
                        >
                          {{
                            (
                              (100 *
                                obj.data.columns
                                  .map(function(el) {
                                    return el.id;
                                  })
                                  .indexOf(obj.data.task.column.id)) /
                              obj.data.columns.length
                            ).toFixed(2)
                          }}
                          %
                        </div>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="text-muted mg-r-10">Бүртгэсэн:</div>
                      <div class="text-right">
                        <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                          {{
                            obj.data.task.createdDate | moment("dddd, HH:mm")
                          }}
                        </h6>
                        <span class="d-block tx-11 text-muted">{{
                          obj.data.task.createdDate | moment("YYYY.MM.DD")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="detail-content-body" style="top: 0px; display: none">
                <div class="detail-content-footer bg-black-1"></div>
              </div>
            </div>
          </div>
          <div
            class="detail-content-sidebar"
            style="padding: 0; display: none"
          ></div>
        </div>
      </div>
    </div>

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="p-4 text-center rounded bg-secondary text-light"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="p-3 text-center"
        >
          <p>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button variant="outline-success" @click="deleteObj()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>

    <action-dialog
      :id="actionDialog.id"
      :mode="actionDialog.mode"
      :key="actionDialog.key + '_ad'"
      :show="actionDialog.show"
      :task="obj.data.task"
      :transferOptions="transferOptions"
      @on-hide="
        actionDialog.id = 0;
        actionDialog.show = false;
        $emit('on-row-updated', obj.data.task.id);
        init();
      "
      @on-transfered="
        $emit('on-row-updated', obj.data.task.id);
        init();
      "
      @on-project-changed="$emit('on-project-changed', id)"
    />
    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
    <view-logs
      @on-attach="showFile"
      :show="viewLogDialog.show"
      :id="viewLogDialog.id"
      @on-hide="viewLogDialog.show = false"
    ></view-logs>
    <b-sidebar
      v-model="courseAnnualObj.modal"
      right
      class="full-mdl"
      size="xl"
      width="100vw"
      title="Сургалтын тайлан"
      @change="visibleChangedCourseAnnual"
    >
      <course-annual :id="courseAnnualObj.courseId" />
    </b-sidebar>
    <send-ics-mail
      @on-hide="icsMailModal.show = false"
      :isShow.sync="icsMailModal.show"
      :prms.sync="icsMailModal.prms"
      :key="icsMailModal.key"
    ></send-ics-mail>

    <share-to-messenger
      @on-hide="shareToMessengerModal.show = false"
      :isShow.sync="shareToMessengerModal.show"
      :prms.sync="shareToMessengerModal.prms"
      :key="shareToMessengerModal.key"
    ></share-to-messenger>

    <b-modal v-model="showValue.mdl" title="Дэлгэрэнгүй" hide-footer>
      <h6
        class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-semibold mg-b-8"
      >
        {{ showValue.obj.field }}
      </h6>
      <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
        {{ showValue.obj.value }}
      </h3>
    </b-modal>

    <b-modal v-model="formPayment.modal" title="Төлбөрийн тохиргоо">
      <form class="pd-20">
        <div class="form-group mg-b-0 row">
          <label class="col-form-label pd-t-20 d-block">Төлбөртэй эсэх?</label>
          <Select v-model="formPayment.setting.hasPayment" class="wd-100p">
            <Option :value="true" :key="1" label="Тийм">Тийм</Option>
            <Option :value="false" :key="-1" label="Үгүй">Үгүй</Option>
          </Select>
        </div>
        <div class="form-group mg-b-0 row">
          <label class="col-form-label pd-t-20 d-block">Төлбөр</label>
          <input
            v-model="formPayment.setting.budget"
            maxlength="450"
            class="form-control"
            placeholder="Төлөрийн хэмжээ оролдлого бүрт"
          />
        </div>
      </form>
      <template #modal-footer>
        <b-button @click="formPayment.modal = false" variant="danger"
          >Болих</b-button
        >
        <b-button @click="formPaymentSubmit" variant="primary"
          >Хадгалах</b-button
        >
      </template>
    </b-modal>

    <b-modal v-model="qrObj.modal" title="Танхимаар ирц бүртгэх" hide-footer>
      <div class="text-center">
        <img class="wd-200" :src="`${qrObj.value}`" />
      </div>
    </b-modal>

    <b-modal
      v-model="ebarimtObj.modal"
      hide-footer
      title="И-Баримт"
      centered
      body-class="pd-0"
      size="md"
      scrollable
    >
      <div class="modal-body" ref="mdlEbarimt" style="font-size: 0.85em">
        <template>
          <div class="pd-md">
            <div class="mb-10 row d-flex">
              <div class="text-center col col-12 m-b-md">
                <h5>
                  {{ ebarimtObj.companyName }}
                </h5>
              </div>
              <div class="col col-4">Огноо</div>
              <div class="text-right col col-8">
                {{ ebarimtObj.ebarimt.date | moment("YYYY.MM.DD HH:mm") }}
              </div>
              <div class="col col-4">ТТД</div>
              <div class="text-right col col-8">
                {{ ebarimtObj.ebarimt.billId }}
              </div>
            </div>
            <table
              class="tbl-stock"
              style="width: 100%"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <th style="width: 30px">Д/д</th>
                <th>Бичилт</th>
                <th style="width: 80px;">Нэгж үнэ</th>
                <th style="width: 30px">Хэмжээ</th>
                <th style="width: 80px">Нийт үнэ</th>
              </thead>
              <tbody>
                <tr
                  v-for="(s, i) in ebarimtObj.ebarimt.stocks"
                  :key="i"
                  style="border-top: 1px solid #000"
                >
                  <td style="text-align: center">{{ i + 1 }}</td>
                  <td style="text-align: left">{{ s.name }}</td>
                  <td>{{ s.unitPrice }}</td>
                  <td>{{ s.qty }}</td>
                  <td>{{ s.totalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row d-flex">
            <div class="text-center col col-12">
              <img :src="`data:image/png;base64, ${ebarimtObj.base64}`" />
              <!-- <qrcode-vue id="qr_canvas" :value="ebarimtObj.ebarimt.qrData" :size="qrOption.size" level="L" ></qrcode-vue> -->
              <!-- {{ebarimtObj.ebarimt}} -->
            </div>
            <div class="text-right col col-5 p-r-xs">Дүн:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.amount }}
            </div>
            <div class="text-right col col-5 p-r-xs">Сугалаа:</div>
            <div class="col col-7" style="font-weight: 700">
              {{ ebarimtObj.ebarimt.lottery }}
            </div>

            <div class="text-right notprint wd-100p">
              <button
                @click="downloadEbarimt()"
                class="btn btn-sm btn-outline-primary notprint mg-r-20"
              >
                ТАТАХ
              </button>
            </div>
          </div>
        </template>
      </div>
    </b-modal>

    <b-modal
      v-model="dzFetchMembers.modal"
      centered
      size="lg"
      title="Зөвлөлийн гишүүдийг эцэслэх"
      hide-footer
      ok-title="Томилох"
      cancel-title="Болих"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div class="table-responsive">
        <table class="table table-bordered mg-b-0">
          <thead>
            <tr>
              <th scope="col">№</th>
              <th scope="col">Доктор</th>
              <th scope="col">Утас</th>
              <th scope="col">И-мэйл</th>
              <th scope="col">Албан тушаал</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, i) in dzFetchMembers.tasks" :key="i">
              <th scope="row">{{ i + 1 }}</th>
              <td>{{ t.user.fullName }}</td>
              <td>{{ t.user.mobile }}</td>
              <td>{{ t.user.email }}</td>
              <td>
                <loc-type-cascader
                  v-model="t.locTypeId"
                  :getParentType="true"
                  locTypekey="dzMemberPosition"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-warning" role="alert">
        Та <b>{{ dzFetchMembers.task.locTypeName }}</b
        >-н зөвлөлд дээрхи <b>{{ dzFetchMembers.tasks.length }}</b> докторыг
        томилх гэж байна.
      </div>
      <footer class="modal-footer">
        <button
          @click="dzFetchMembers.modal = false"
          type="button"
          class="btn btn-secondary"
        >
          Болих
        </button>
        <button @click="fetchDzMembers" type="button" class="btn btn-primary">
          Томилох
        </button>
      </footer>
    </b-modal>
    <b-modal v-model="mtaUserSync.modal" centered title="мэдээлэл илгээх">
      <Form
        v-if="!mtaUserSync.finished"
        label-position="right"
        label-width="100px"
      >
        <FormItem label="ICode">
          <input
            v-model="mtaUserSync.username"
            maxlength="100"
            class="form-control"
            placeholder="ICode"
          />
        </FormItem>
        <FormItem label="Нууц үг">
          <input
            v-model="mtaUserSync.password"
            maxlength="100"
            class="form-control"
            type="password"
            placeholder="Нууц үг"
          />
        </FormItem>
      </Form>
      <div v-else class="p-20">
        <div v-html="mtaUserSync.msg"></div>
      </div>
      <template #modal-footer > 
        <!-- <b-button @click="lrningRpt.modal" variant="danger">Болих</b-button> -->
        <b-button v-if="!mtaUserSync.finished" @click="mtaUserSyncStart" variant="primary"
          >Мэдээлэл татах</b-button
        >
        <a v-else></a>
      </template>
    </b-modal>

    <b-modal v-model="fetchExamObj.modal" centered title="Цахим шалгалтын дүн татах">
      <Form
        label-position="right"
        label-width="200px"
      >
        <FormItem label="Хэрэгллэгчийн бүртгэл">
          <Checkbox v-model="fetchExamObj.oldDataSync" label="Sync хийх эсэх ?" />
        </FormItem>
      </Form>
      <template #modal-footer > 
        <b-button @click="fetchExamObj.modal = false" variant="danger">Болих</b-button>
        <b-button @click="fetchExamConfirm" variant="primary">Татах</b-button>
      </template>
    </b-modal>

    <b-modal v-model="resParlEvalModal.modal" centered title="Үнэлгээ оруулах">
      <Form
        v-if="!resParlEvalModal.finished"
        label-position="right"
        label-width="100px"
      >
        <FormItem label="Үнэлгээ">
          <input
            v-model="obj.data.task.fl3"
            maxlength="100"
            class="form-control"
            placeholder="Үнэлгээ"
          />
        </FormItem>
      </Form>
      <div v-else class="p-20">
        <div v-html="resParlEvalModal.msg"></div>
      </div>
      <template #modal-footer > 
        <!-- <b-button @click="lrningRpt.modal" variant="danger">Болих</b-button> -->
        <b-button v-if="!resParlEvalModal.finished" @click="resParlEvaluateStart" variant="primary"
          >Үнэлгээ оруулах</b-button
        >
        <a v-else></a>
      </template>
    </b-modal>

    <b-modal v-model="stfRemovedList.show" centered hide-footer title="Хасагдсан шинжээчид">
      <table class="table wd-100p table-bordered table-striped">
        <tbody>
          <thead>
            <th style="width: 40px">№</th>
            <th>Хэрэглэгч</th>
            <th>Нэвтрэх нэр</th>
            <th>Хасагдсан огноо</th>
            <th>Шалтгаан</th>
          </thead>
          <tbody>
            <tr v-for="(t,ti) in stfRemovedList.list" :key="`dsf_${ti}`">
              <td>{{ ti+1 }}</td>
              <td>{{ t.task }}</td>
              <td>{{ t.loginName }}</td>
              <td>{{ t.flagDate  | moment("YY.MM.DD HH:mm") }}</td>
              <td>{{ t.tsoholt }}</td>
            </tr>
          </tbody>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import { getColumnListByTaskId } from "@/api/column";
import { taskInheritedDetail } from "@/api/task";
import { getDetailFields } from "@/api/taskCore";

import { getTaskPinnedUsers } from "@/api/taskInUser";

import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
// import videoConference from "@/components/modules/videoConference";

import { hasOneOf } from "@/libs/tools";

import loader from "@/components/box/loader/loader.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";

const moment = require("moment");
import boxes from "@/components/task/detail/ot/complms/boxes.vue";

import "element-ui/lib/theme-chalk/index.css";
import {
  Select,
  Option,
  DatePicker,
  Notification,
  Message,
  Menu,
  SubMenu,
  MenuItem,Form, FormItem, MessageBox, Checkbox
} from "element-ui";

//import QrcodeVue from "qrcode.vue";

var $ = window.$;
export default {
  name: "taskDetail",
  components: {
    //QrcodeVue,
    Select,
    Option,
    DatePicker,
    Notification,
    Menu,
    SubMenu,
    MenuItem, Form, FormItem, Checkbox,
    MessageBox,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    menuTask: () => ({
      component: import("@/components/main/menuTask.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    loader,
    boxes,
    vueCustomScrollbar,
    // videoConference,
    courseAnnual: () => ({
      component: import("@/components/modules/lms/courseAnnual.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // taskLoader: () => ({
    //   component: import("@/components/task/detail/ot/loader.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 15000
    // }),
    // forumDetail: () => ({
    //   component: import("@/components/task/detail/special/forum.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // forumTopicDetail: () => ({
    //   component: import("@/components/task/detail/special/forumTopic.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    youtubeDetail: () => ({
      component: import("@/components/task/detail/special/youtube.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskUsers: () => ({
      component: import("@/components/task/components/users"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskActions: () => ({
      component: import("@/components/task/components/actions"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    actionDialog: () => ({
      component: import("@/components/task/components/actions/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    viewLogs: () => ({
      component: import("@/components/task/components/logs/viewLogs"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // taskMention: () => ({
    //   component: import("@/components/task/components/mention/dialog.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // executionDialog: () => ({
    //   component: import("@/components/task/components/executions/dialog.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    executionList: () => ({
      component: import("@/components/task/components/executions/list.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    executionReply: () => ({
      component: import("@/components/task/components/executions/reply.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    transfers: () => ({
      component: import("@/components/task/components/transfers"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userPermission: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userPermission: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    assignProject: () => ({
      component: import("@/components/user/assign.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cancelProject: () => ({
      component: import("@/components/user/cancel.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examChart: () => ({
      component: import("@/components/task/components/dialogs/examChart.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskProcess: () => ({
      component: import("@/components/task/components/transfers/activity.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    courseInfo: () => ({
      component: import(
        "@/components/task/detail/ot/components/infoCourse.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskUsersPinned: () => ({
      component: import(
        "@/components/task/detail/ot/components/usersPinned.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mdlUserroleChange: () => ({
      component: import(
        "@/components/task/components/hrmenu/mdlUserroleChange.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mdlUserpassChange: () => ({
      component: import(
        "@/components/task/components/hrmenu/mdlUserpassChange.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mdlUsernameChange: () => ({
      component: import(
        "@/components/task/components/hrmenu/mdlUsernameChange.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mdlUserstateChange: () => ({
      component: import(
        "@/components/task/components/hrmenu/mdlUserStateChange.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    sendIcsMail: () => ({
      component: import("@/components/task/detail/special/sendIcsMail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    shareToMessenger: () => ({
      component: import("@/components/modules/messenger/shareToMessenger"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    courseAttendence: () => ({
      component: import("@/components/task/detail/special/attendence.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0,
    },
    boxId: {
      type: Number,
      default: () => 0,
    },
    parentTask: {
      type: Object,
      default: () => {},
    },
    detailSettingProp: {
      type: Object,
      default: () => null,
    },
    hideMentionUsers: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      stfRemovedList:{
        show: false,
        list:[]
      },
      canvasnav: {
        module: 0,
        overlay: false,
      },
      dzFetchMembers: {
        tasks: [],
        task: {},
        modal: false,
      },
      detailMenuSetting: {
        hideEmail: false,
      },
      detailSetting: {
        hideMainMenu: false,
        showMiniMenu: false,
        hideToolbar: false,
        leftSideHide: false,
        leftSideHeight: 0,
        hideRightSidebar: false,

        hideExecution: false,
        hideProcess: false,
        hideMembers: false,

        boxSetting: {
          hideToolbar: false,
          hideAddButton: false,
          listSetting: {
            height: 500,
            disableDetail: false,
          },
        },
      },
      examChartObj: {
        id: 0,
        show: false,
      },
      fields: [],
      fetched: false,
      boxLoading: true,
      activeBox: {
        id: 0,
        ot: 0,
      },
      activeTab: {
        loading: false,
        rdy: false,
        ind: 1,
      },
      obj: {
        code: 0,
        data: {
          columns: [],
          task: {},
          pinnedUsers: [],
          transfers: [],
        },
      },
      taskUsersKey: 0,
      taskActionsKey: 0,
      mentionDialog: {
        show: false,
        afterData: {},
      },
      executionDialog: {
        show: false,
        id: 0,
        key: 0,
      },
      transfersDialog: {
        show: false,
        id: 0,
        key: 0,
      },
      fileDialog: {
        show: false,
        id: 0,
      },

      transferOptions: {
        taskColumns: [],
        canFinishTask: false,
        canReturnTask: false,
        canChangeProject: false,
        skipAfterColumn: {
          id: 0,
          name: "",
        },
        primaryTsoholt: false,
        hasAcceptColumn: false,
        hasAcceptObjectType: 0,
        isFirstColumn: false,
      },
      actionDialog: {
        id: 0,
        mode: null,
        key: 0,
        show: false,
      },
      box: {
        active: 0,
        slider: false,
        attachments: [],
        tasks: [],
      },
      taskEdit: {
        id: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
        parentTask: {},
      },
      projectEdit: {
        id: 0,
        redner: false,
        show: false,
        mode: 0,
      },
      projectMention: {
        module: "task",
        show: false,
      },
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0,
        boxId: 0,
      },
      scrHeight: {
        execution: 600,
        executionReply: 600,
      },
      processing: false,
      busy: false,
      processingObj: {
        id: 0,
        module: "task",
      },
      mdlUserJSON: {
        taskId: 0,
        locTypeId4: 0,
        new: "",
        userId: "",
      },
      mdlUsernameChange: false,
      mdlUserroleChange: false,
      mdlUserpassChange: false,
      mdlUserstateChange: false,
      viewLogDialog: {
        show: false,
        id: 0,
      },
      courseAnnualObj: {
        modal: false,
        courseId: 0,
      },
      icsMailModal: {
        show: false,
        prms: {
          courseId: 0,
          objectId: 0,
          boxId: 0,
          objectTypeId: 0,
        },
        key: 0,
      },
      shareToMessengerModal: {
        show: false,
        prms: {
          objectId: 0,
          objectTypeId: 0,
        },
        key: 1500,
      },
      showValue: {
        mdl: false,
        obj: {
          field: "",
          value: "",
        },
      },
      boxMenuCount: 0,
      formPayment: {
        modal: false,
        setting: {
          boxId: null,
          budget: null,
          formId: null,
          hasPayment: false,
        },
        formId: 0,
        boxId: 0,
      },

      qrObj: {
        task: null,
        modal: false,
        value: "",
        size: 150,
      },
      cancelProject: {
        id: 0,
        redner: false,
        show: false,
        mode: 0,
      },
      assignProject: {
        id: 0,
        redner: false,
        show: false,
        mode: 0,
      },
      completeProject: {
        id: 0,
        redner: false,
        show: false,
        mode: 0,
        obj: {},
        flag: null,
        desc: null,
      },
      ebarimtObj: {
        modal: false,
        key: 0,
        id: 0,
        type: null,
        regNo: "",
        ebarimt: {},
        base64: null,
        obj: {},
      },
      qrIdObj: {
        img: null,
        modal: false,
      },
      fetchExamObj:{
        modal: false,
        oldDataSync: false,
      },
      resParlEvalModal:{
        modal: false,
        finished: false,
        msg: ""
      },
      mtaUserSync: {
        modal: false,
        finished: false,
        msg: "",
        username: "",
        password: "",
        serviceId: null,
      },
    };
  },
  mounted() {
    require("@/assets/css/dynamic.detail.css");

    this.setTransferOptions();

    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowHeight);
      //this.getWindowHeight();
    });

    let _companyName = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "companyName"
    );
    if (_companyName.length > 0) {
      this.ebarimtObj.companyName = _companyName[0].value;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    projStfRemovedShinjeechid(task){
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "project_stf_butsaasan_shinjeechid",
          exportMode: 2,
          params: [
            {
              name: "taskId",
              value: task.id
            }
          ]
        }
      }).then(res => {
        if (res != false) {
          // console.log('res', res);
          this.stfRemovedList.list=res.data;
          this.stfRemovedList.show=true;
        }
      });
    },
    fetchExamResult(){
      this.fetchExamObj.modal=true;
      console.log('fetchExamResult', this.obj.data.task);
    },
    fetchExamConfirm(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/ImportExamResultFromCourse" },
        data: {
          id: this.obj.data.task.id,
          oldDataSync: this.fetchExamObj.oldDataSync,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          Message({
            message: "Амжилттай татагдлаа.",
            type: "success",
          });
          this.fetchExamObj.modal=false;
        }
      });
    },
    resParlEvaluate(id){
      this.resParlEvalModal.modal=true;
    },
    resParlEvaluateStart(id){
      //his.resParlEvalModal.modal=true;
      MessageBox.confirm(
        "Та үнэлгээ илгээхдээ итгэлтэй байна уу ?",
        "Санам",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          type: "warning",
        }
      )
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "POST",
              url: "ResearchParliament/CalcPoint",
            },
            data: {
              id: this.obj.data.task.id,
              calcPoint: this.obj.data.task.fl3
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              Message({
          message: "Амжилттай хадгаллаа.",
          type: "success",
        });
              this.resParlEvalModal.modal=false;
              //this.init();
              this.$emit("on-box-reload", {ot: 623});
              this.$emit("on-task-reload", {id: this.obj.data.task.id});
              
              // this.taskDialogSide.id = 0;
            }
          });
        })
        .catch(() => {});
    },
    sendMessageNotif(id){
      MessageBox.confirm(
        "Та мэдэгдэл илгээхдээ итгэлтэй байна уу ?",
        "Санам",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          type: "warning",
        }
      )
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "POST",
              url: "MessageNotif/SendZarMessage",
            },
            data: {
              id: id
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {              
              //this.$Message.success("Амжилттай илгээлээ.");
              Message({
          message: "Амжилттай илгээлээ.",
          type: "success",
        });
              this.$emit("on-task-reload", {id: id});
              //this.init();
            }
          });
        })
        .catch(() => {});
    },
    mtaUserSyncStart() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: {
          method: "post",
          url: "TAIS/PostData",
        },
        data: {
          username: this.mtaUserSync.username,
          password: this.mtaUserSync.password,
          serviceId: this.mtaUserSync.serviceId,
          objectId: this.obj.data.task.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // this.showFile(res.data.file.id);
          // this.lrningRpt.modal = false;
          this.mtaUserSync.finished = true;
          this.mtaUserSync.msg = res.data.msg;
        }
      });
    },
    sendTaisInfo(serviceId) {
      this.mtaUserSync.serviceId = serviceId;
      this.mtaUserSync.modal = true;
    },
    genQr(task) {
      try {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Qr/Generate" },
          data: {
            qr: `https://asset.gosmart.mn/#/login?id=${task.id}`,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.qrIdObj.img = res.data.base64;
            this.$nextTick(() => {
              this.qrIdObj.modal = true;
            });

            // console.log('res', res);
            // this.dzFetchMembers.modal = false;
            // this.$refs["box_" + this.dzFetchMembers.task.b[0]["id"]][0].reInit(
            //   true
            // );
            // Notification.info({
            //   title: "Амжилттай",
            //   message: `Зөвлөлийн гишүүдийг баталлаа`,
            //   duration: 5000,
            //   position: "bottom-right",
            // });
          }
        });
      } catch (ee) {
        // throw
      }
    },
    doPostMembers(arr) {
      // console.log('arr', arr)
      try {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInheritedMultiple" },
          data: arr,
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.dzFetchMembers.modal = false;
            this.$refs["box_" + this.dzFetchMembers.task.b[0]["id"]][0].reInit(
              true
            );
            Notification.info({
              title: "Амжилттай",
              message: `Зөвлөлийн гишүүдийг баталлаа`,
              duration: 5000,
              position: "bottom-right",
            });
          }
        });
      } catch (ee) {
        // throw
      }
    },
    fetchDzMembers() {
      // console.log('todo', this.dzFetchMembers.task);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          objectTypeId: 602,
          parentId: this.dzFetchMembers.task.id,
          projectId: this.dzFetchMembers.task.projectId,
          boxId: this.dzFetchMembers.task.b[0]["id"],
          userId: this.dzFetchMembers.task.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let parr = [];

          let _pid = 0;
          let proj = this.$store.state.app.groupDefaultProjects.filter(
            (x) => x.objectTypeId == 602
          );
          if (proj.length) {
            _pid = proj[0].id;
          }

          for (let i = 0; i < this.dzFetchMembers.tasks.length; i++) {
            // let psttsk= res.data.task;
            let psttsk = JSON.parse(JSON.stringify(res.data.task));
            // console.log('sds', this.dzFetchMembers.tasks[i]['user']);

            psttsk.parentId = 0;
            psttsk.projectId = _pid;

            psttsk.task = this.dzFetchMembers.tasks[i]["user"]["fullName"];
            psttsk.userId = this.dzFetchMembers.tasks[i]["user"]["userId"];
            // psttsk.locTypeId= this.dzFetchMembers.tasks[i]['locTypeId'];

            psttsk.isTender = false;

            psttsk.organizationTaskId = this.id; //# zuvluliin id hadgalj bna
            psttsk.secondOrganizationTaskId = this.dzFetchMembers.tasks[i][
              "user"
            ]["id"]; //# user profile id hadgalj bna
            psttsk.thirdOrganizationTaskId = this.dzFetchMembers.tasks[i]["id"]; //# huseltiin id
            psttsk.fourthOrganizationTaskId = this.dzFetchMembers.tasks[i][
              "organizationTaskId"
            ]; //# zariin id hadgalj bna
            psttsk.locTypeId1 = this.dzFetchMembers.tasks[i]["locTypeId"]; //# gishvvnii alban tushaal

            parr.push(psttsk);
            // console.log('psttsk.task', parr[i]['task']);
            if (this.dzFetchMembers.tasks.length - 1 == i) {
              this.doPostMembers(parr);
            }
          }
          // console.log(parr[0].task);

          // this.$nextTick(()=>{
          //   console.log('parr', parr[0]['task'], parr[1]['task']);
          // })
        }
      });
    },
    dzStfDownloadMembers(task) {
      // console.log('task', task.task, task.id, task.);
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 599
      );
      if (proj.length) {
        _pid = proj[0].id;
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          projectId: _pid,
          skip: 0,
          size: 2000,
          id: 0,
          model: {
            locTypeId: 346691, //# Зөвлөлд шалгарсан
            locTypeId1: task.locTypeId, //# uusgej bui zuvluliin turul huselt ilgeesen chigleltei match bh
          },
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log("res", res.data.tasks);
          this.dzFetchMembers.tasks = res.data.tasks;
          this.dzFetchMembers.task = task;
          this.dzFetchMembers.modal = true;
        }
      });
    },
    assnClosed() {
      this.assignProject.show = false;
      this.$nextTick(() => {
        this.init();
      });
    },
    ...mapActions([
      "handleLoading",
      "handleMainReportDialog",
      "handleMessenger",
      "handleUserInfoModal",
    ]),
    teacherReportData(task) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "report/teacherReportData" },
        params: { teacherId: this.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    checkChatAvailableOts(ot) {
      let ots = [154, 115, 325, 536];
      return ots.includes(ot);
    },
    openChat() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Team/CreateTeamByTaskId" },
        data: { taskId: this.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let _tmid = res.data.teamId;
          if (_tmid != undefined && _tmid != null && _tmid > 0) {
            let obj = this.$store.state.app.messenger;
            obj.openId = _tmid;
            obj.activeFlag = res.data.flag;
            obj.open = true;
            this.handleMessenger(obj).then(() => {
              this.visibleChanged(false);
            });
          }
          //console.log('CreateTeamByTaskId', res.data);
        }
      });
    },
    downloadEbarimt() {
      var _content = this.$refs.mdlEbarimt.innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=400");

      mywindow.document.write("<html><head><title>Print</title>");
      mywindow.document.write("</head><body >");
      mywindow.document.write(_content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },
    ebarimtPrint(e) {
      request({
        api: { method: "POST", url: "EBarimt/CheckEBarimt" },
        store: this.$store,
        data: { id: e.id },
      }).then((res) => {
        if (res != false) {
          request({
            api: { method: "POST", url: "QR/Generate" },
            store: this.$store,
            data: { qr: res.data.ebarimt.qrData },
          }).then((res) => {
            if (res != false) {
              this.ebarimtObj.base64 = res.data.base64;
            }
          });
          this.ebarimtObj.mode = 2;
          this.ebarimtObj.ebarimt = res.data.ebarimt;
          this.ebarimtObj.modal = true;
          this.ebarimtObj.key++;
        }
      });

      // this.ebarimtObj.obj= e;
      // this.ebarimtObj.modal= true;
    },
    ebarimtReturn(e) {
      if (
        confirm("Итгэлтэй байна уу. Үйлдлийг зөвшөөрснөөр буцаах боломжгүй ?")
      ) {
        request({
          api: { method: "POST", url: "EBarimt/ReturnBill" },
          data: { id: e.id },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.init();
            //this.$emit("update-version");
          }
        });
      }
    },
    copyCourseLink() {
      //console.log('copied')
      //console.log(window.location)
      this.$refs.courseLink.value =
        window.location.protocol +
        "//" +
        window.location.host +
        "/#/lms/courseView/" +
        this.id +
        "/0/0/0";
      this.$refs.courseLink.focus();
      var successful = document.execCommand("copy");
      if (successful) {
        Notification.success({
          message: "Сургалтын үзэх холбоос амжилттай хуулагдлаа.",
          duration: 3000,
          type: "success",
          position: "top-right",
          offset: 50,
        });
      }

      //console.log(successful)
      //clipboard.writeText('343100195073');
      //document.execCommand('copy');
    },
    mailerLite(mode) {
      let _url = "";
      if (mode == 1) {
        _url = "MailerLite/PostMailData";
      } else if (mode == 2) {
        _url = "MailerLite/SendMail";
      }
      this.busy = true;
      this.processing = true;
      request({
        api: { method: "POST", url: _url },
        data: { id: this.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.processing = false;
          this.busy = false;
          this.$bvToast.toast("Амжилттай", {
            title: "Амжилттай",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },
    shareToMessenger() {
      this.shareToMessengerModal.prms.objectId = this.obj.data.task.id;
      this.shareToMessengerModal.prms.objectTypeId = this.obj.data.task.objectTypeId;
      this.shareToMessengerModal.show = true;
      this.shareToMessengerModal.key++;
    },
    sendIcsMail() {
      // if (this.obj.data.task.objectTypeId == 115) {
      //   this.icsMailModal.prms.courseId = this.id;
      // }
      if (this.obj.data.task.objectTypeId == 500) {
        this.icsMailModal.prms.courseId = this.obj.data.task.parentTask.id;
        this.icsMailModal.prms.objectId = this.id;
        this.icsMailModal.prms.boxId = this.boxId;
      } else {
        this.icsMailModal.prms.courseId = this.id;
      }

      this.icsMailModal.prms.objectTypeId = this.obj.data.task.objectTypeId;
      this.icsMailModal.show = true;
      this.icsMailModal.key++;
    },
    getWindowHeight() {
      if (this.activeTab.ind == 1) {
        let extraSide = 0;
        // this.$nextTick(()=>{
        //   console.log('this.$refs', this.$refs);
        //   console.log('     this.$refs', this.$refs.goTaskFooter);

        //   //alert(1);

        //   //extraSide += this.$refs.detailMainNav.offsetHeight;
        //   extraSide += this.$refs.detailNavTab.offsetHeight;
        //   extraSide += this.$refs.goTaskFooter.offsetHeight;
        // });

        // if(this.$refs.detailNavTab!=undefined && this.$refs.goTaskFooter!=undefined){
        //   extraSide += this.$refs.detailNavTab.offsetHeight;
        //   extraSide += this.$refs.goTaskFooter.offsetHeight;
        // } else if(this.$refs.detailNavTab!=undefined){
        //   extraSide += 55+this.$refs.detailNavTab.offsetHeight;
        // } else if(this.$refs.goTaskFooter!=undefined){
        //   extraSide += 65+this.$refs.goTaskFooter.offsetHeight;
        // } else{
        //   extraSide += 55+65;
        // }

        extraSide += document.getElementById("detailNavTabId").offsetHeight;
        extraSide += document.getElementById("goTaskFooterId").offsetHeight;

        this.scrHeight.execution = window.innerHeight - extraSide;
        //alert(extraSide);
      } else if (this.activeTab.ind == 2) {
        let extraSide =
          0 +
          this.scrHeight.executionReply +
          this.$refs.detailNavTab.offsetHeight +
          this.$refs.detailMainNav.offsetHeight;
        this.scrHeight.execution = window.innerHeight - extraSide;
      }
    },
    hasOneOf(tarr, arr) {
      return hasOneOf(tarr, arr);
    },
    fieldsAfter(ot) {
      if (this.$store.state.app.activeGroup.id == 9344) {
        if (ot == 138 || ot == 390) {
          this.fields = this.fields.filter((x) => x.field != "langCode");
          // this.fields.forEach((f) => {
          //   if (f.field == "langCode" ) {

          //     f.flag = null;
          //   }
          // });
        }
      }
    },
    initFields(ot) {
      getDetailFields({ params: { objectTypeId: ot } }).then((res) => {
        if (res != false) {
          this.fields = res.data.fields;
          this.fieldsAfter(ot);
          this.fetched = true;

          this.changeTab(1);
        }
      });
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    initAfter() {
      if (
        this.obj.data.task.objectTypeId == 115 ||
        this.obj.data.task.objectTypeId == 114
      ) {
        this.detailSetting.hideProcess = true;
        this.detailSetting.hideExecution = true;
        this.detailSetting.hideMembers = true;
        //Mail/GetAdminUserMailSetting
        if (this.obj.data.task.objectTypeId == 115) {
          request({
            api: { method: "GET", url: "Mail/GetAdminUserMailSetting" },
            store: this.$store,
          }).then((res) => {
            // console.log('res', res);
            if (res != false && res.data.result == 0) {
              this.detailMenuSetting.hideEmail = true;
            }
          });
        }
      } else if (
        this.obj.data.task.objectTypeId == 512 ||
        this.obj.data.task.objectTypeId == 513
      ) {
        this.detailSetting.hideMainMenu = true;
      } else if (
        this.obj.data.task.objectTypeId == 138 ||
        this.obj.data.task.objectTypeId == 390
      ) {
        this.obj.data.task.b = this.obj.data.task.b.filter((x) => x.ot != 268 && x.ot != 636);
      }
    },
    init(boxId) {
      this.fetched = false;
      if (this.detailSettingProp != null) {
        this.detailSetting = this.detailSettingProp;
      }

      //console.log(this.$refs.toolbar.offsetHeight);

      this.detailSetting.leftSideHeight =
        window.innerHeight - this.$refs.toolbar.offsetHeight;
      //console.log(this.detailSetting.leftSideHeight)

      this.$nextTick(() => {
        this.handleLoading({ isLoading: true });

        taskInheritedDetail({
          params: { id: this.id, sourceFlag: 1 },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            // console.log('res taskInheritedDetail', res);
            this.obj.data.columns = res.data.columns;
            this.obj.data.task = res.data.task;

            this.initAfter();

            this.obj.data.task.b
              .filter((x) => x.ot == 124)
              .map((b) => {
                b.otCompName = "coreBox";
              });
            this.obj.data.task.b
              .filter(
                (x) =>
                  x.ot == 389 ||
                  x.ot == 116 ||
                  x.ot == 117 ||
                  x.ot == 416 ||
                  x.ot == 503
              )
              .map((b) => {
                b.otCompName = "system/form";
              });

            this.obj.data.task.b
              .filter((x) => x.ot == 286 || x.ot == 123)
              .map((b) => {
                b.otCompName = "system/attachment";
              });
            this.obj.data.task.b
              .filter(
                (x) =>
                  x.ot == 389 ||
                  x.ot == 116 ||
                  x.ot == 117 ||
                  x.ot == 416 ||
                  x.ot == 503
              )
              .map((b) => {
                b.otCompName = "system/form";
              });

            if (
              this.obj.data.task.objectTypeId == 154 &&
              this.hasPermission(["crmclient"])
            ) {
              this.obj.data.task.b = this.obj.data.task.b.filter(
                (x) =>
                  x.ot == 402 ||
                  x.ot == 411 ||
                  x.ot == 412 ||
                  x.ot == 417 ||
                  x.ot == 421 ||
                  x.ot == 458 ||
                  x.ot == 531
              );
            }

            // (b.ot==293? hasPermission(['learningadmin']) : b.ot==343 ? task.objectTypeId==280 ? true: !hasPermission(['learningstudent']) : true && ( (b.settingFlag==10 ||b.settingFlag==20 || b.settingFlag==50 )? task.systemFlag!=6 : true ))
            // && (task.objectTypeId==154 && hasPermission(['crmclient']) ? ((b.ot==402 || b.ot==411 || b.ot==412 || b.ot==417 || b.ot==421 || b.ot==458) ? true : false)  : true )
            //   && (b.ot==342 ?  !hasPermission(['learningstudent']): true)

            this.initFields(res.data.task.objectTypeId);
            if (
              this.obj.data.task.b != undefined &&
              this.obj.data.task.b.length
            ) {
              // console.log('this.obj.data.task.b', this.obj.data.task.b);
              if (boxId != undefined) {
                let tempBox = this.obj.data.task.b.filter((x) => x.id == boxId);
                if (tempBox.length > 0) this.activeBox = tempBox[0];
              } else if(this.obj.data.task.objectTypeId == 622 && this.obj.data.task.b.filter((x) => x.ot == 623).length > 0) {
                this.activeBox = this.obj.data.task.b.filter((x) => x.ot == 623)[0];
              } else this.activeBox = this.obj.data.task.b[0];
              //this.loadBoxData(this.obj.data.task.b[0]);
            } else {
              this.boxLoading = false;
            }
            getTaskPinnedUsers({
              params: { taskId: this.id, page: 0, size: 20 },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.obj.data.pinnedUsers = res.data.users;
              }
            });
            if (
              moment(res.data.task.lastMyViewDate).isBefore(
                res.data.task.lastExecutionDate
              ) ||
              moment(res.data.task.lastMyViewDate).isBefore(
                res.data.task.lastTransferDate
              )
            ) {
              if (
                moment(res.data.task.lastTransferDate).isBefore(
                  res.data.task.lastExecutionDate
                )
              ) {
                this.changeTab(2);
              } else {
                this.changeTab(3);
              }
            }

            this.$emit("on-task-loaded", res.data);
          } else {
          }
        });
      });
    },
    getColumnColor(c, i) {
      if (
        this.obj.data.task.column != null &&
        c.id == this.obj.data.task.column.id
      ) {
        return "orange";
      } else if (
        this.obj.data.task.column != null &&
        this.obj.data.columns
          .map(function(c) {
            return c.id;
          })
          .indexOf(this.obj.data.task.column.id) > i
      ) {
        return "green";
      } else if (this.obj.data.task.column == null) {
        return "green";
      } else {
        return "grey";
      }
    },
    getColumnIcon(c, i) {
      if (
        this.obj.data.task.column != null &&
        c.id == this.obj.data.task.column.id
      ) {
        return "mdi-chevron-right";
      } else if (
        this.obj.data.task.column != null &&
        this.obj.data.columns
          .map(function(c) {
            return c.id;
          })
          .indexOf(this.obj.data.task.column.id) > i
      ) {
        return "mdi-account-check";
      } else if (this.obj.data.task.column == null) {
        return "mdi-account-check";
      } else {
        return "";
      }
    },
    setTransferOptions() {
      getColumnListByTaskId({
        params: { taskId: this.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if (this.id > 0) this.init();
          this.transferOptions.taskColumns = res.data.columns;
          this.transferOptions.canFinishTask = res.data.canFinish;
          this.transferOptions.canReturnTask = res.data.canReturn;

          this.transferOptions.canChangeProject = res.data.canProjectChange;
          let _acceptColumn = this.transferOptions.taskColumns.filter(
            (x) => x.settingFlag == 1 && x.direction == 1
          );

          if (_acceptColumn.length > 0) {
            this.transferOptions.hasAcceptColumn = true;
            this.transferOptions.hasAcceptObjectType =
              res.data.task.objectTypeId;
            if (res.data.task.objectTypeId == 157) {
              this.transferOptions.primaryTsoholt = false;
            }
          }

          let currentColumn = this.transferOptions.taskColumns.filter(
            (x) => x.direction == 1
          );
          if (currentColumn.length > 0) {
            this.transferOptions.isFirstColumn = currentColumn[0].ord == 1;
          }
          let _skipColumn = this.transferOptions.taskColumns.filter(
            (x) => x.skipAfterColumnId != 0 && x.direction == 1
          );
          if (_skipColumn.length > 0) {
            this.transferOptions.skipAfterColumn.id =
              _skipColumn[0].skipAfterColumnId;

            if (
              this.transferOptions.taskColumns.filter(
                (x) => x.id == this.transferOptions.skipAfterColumn.id
              ).length > 0
            ) {
              this.transferOptions.skipAfterColumn.name = this.transferOptions.taskColumns.filter(
                (x) => x.id == this.transferOptions.skipAfterColumn.id
              )[0].title;
            }
          }
        } else {
          this.$emit("on-task-close");
        }
      });
    },
    showExecution(e) {
      this.executionDialog.id = e.id;
      this.executionDialog.show = true;
    },
    showTransfers(e) {
      this.transfersDialog.id = e.id;
      this.transfersDialog.show = true;
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    openOrAssignColumn(id, mode) {
      //console.log('openOrAssignColumn', mode);
      if (mode == 22) {
        this.transferOptions.canFinishTask = true;
        //this.actionDialog.mode = 2;
      }

      this.actionDialog.mode = mode;

      this.actionDialog.id = id;
      this.actionDialog.show = true;
    },
    loadBoxData(b) {
      //console.log('loadBoxData', b);
      if (this.activeBox.id != b.id) {
        this.boxLoading = true;
        this.activeBox = b;
      }
    },
    onBoxReload(boxId) {
      //console.log('onBoxReload', boxId);
      this.init(boxId);
    },
    boxItemCount(b) {
      let rv = "";
      switch (b.ot) {
        case 6:
        case 123:
        case 388:
        case 337:
        case 363:
        case 306:
        case 339:
        case 359:
        case 248:
        case 286:
          rv = b.taskCount + " хавсралттай";
          break;
        case 116:
        case 117:
        case 389:
          rv = b.taskCount + " формтой";
          break;
        default:
          rv = b.taskCount + " бичилттэй";
          break;
      }

      return rv;
    },
    editBox(e) {
      this.$refs["detailBoxes"].boxmodalRename(e);
    },
    deleteBoxConfirm(e) {
      this.processingObj = { id: e.id, module: "box" };
      this.busy = true;
    },
    editShow(e) {
      if (e.objectTypeId == 138 && this.hasPermission(["membermanager"])) {
        this.$emit("on-edit-profile", e);
      } else {
        this.taskEdit.id = e.id;
        this.taskEdit.objectTypeId = e.objectTypeId;
        this.taskEdit.projectId = e.projectId;
        if (e.mode == 2) {
          this.taskEdit.boxId = e.boxId;
          this.taskEdit.parentId = this.obj.data.task.id;
          this.taskEdit.parentTask = this.obj.data.task;
        }
        this.taskEdit.render = true;
        this.$nextTick(function() {
          this.taskEdit.show = true;
        });
      }
    },
    editClosed(boxId) {
      //console.log("cklose is here then ", boxId)
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
      if (boxId != undefined) this.init(boxId);
    },
    deleteShow(e) {
      this.processingObj = { id: e.id, module: "task" };
      this.busy = true;
    },
    taskDeleted(e) {
      try {
        if (this.activeBox.id != 0) {
          if (
            this.$refs["box_" + this.activeBox.id] != undefined &&
            this.$refs["box_" + this.activeBox.id].length > 0
          ) {
            //this.$refs['box_'+e.prms.boxId][0].reInit(e);
            this.$refs["box_" + this.activeBox.id][0].taskDeleted(e);
          }
        }
      } catch {}
    },
    deleteObj() {
      if (this.processingObj.module == "task") {
        this.deleteTask();
      } else if (this.processingObj.module == "box") {
        this.deleteBox();
      } else if (this.processingObj.module == "duplicate") {
        this.duplicateCourseConfirm();
      }
    },
    deleteTask() {
      this.processing = true;
      request({
        api: { method: "GET", url: "Task/DeleteBefore" },
        params: { id: this.processingObj.id },
        store: this.$store,
      }).then((res) => {
        this.processing = false;
        if (res != false) {
          if (res.data.result == 1) {
            this.processing = true;
            request({
              api: { method: "POST", url: "Task/Delete" },
              params: { id: this.processingObj.id },
              store: this.$store,
            }).then((res) => {
              this.processing = false;
              if (res != false) {
                if (res.data.result == 1) {
                  this.busy = false;
                  this.$bvToast.toast("Амжилттай", {
                    title: "Амжилттай",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                  this.visibleChanged(false);
                  this.$emit("on-task-delete", res.data.id);
                } else {
                  this.$bvToast.toast(`${res.data.info}`, {
                    title: "Амжилтгүй",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                }
              }
            });
          } else {
            this.busy = false;
            this.processing = false;
            this.$bvToast.toast(`${res.data.info}`, {
              title: "Амжилтгүй",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        } else {
          this.$bvToast.toast(`${res.data.info}`, {
            title: "Амжилтгүй",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },
    deleteBox() {
      this.processing = true;
      request({
        api: { method: "POST", url: "Box/Delete" },
        data: { id: this.processingObj.id },
        store: this.$store,
      }).then((res) => {
        this.processing = false;
        if (res != false) {
          this.busy = false;
          this.$bvToast.toast("Амжилттай", {
            title: "Амжилттай",
            autoHideDelay: 5000,
            appendToast: true,
          });
          this.init(this.processingObj.id);
        }
      });
    },
    taskPosted(e) {
      //console.log('taskPosted', e);
      if (e.prms.boxId != undefined) {
        if (
          this.$refs["box_" + e.prms.boxId] != undefined &&
          this.$refs["box_" + e.prms.boxId].length > 0
        ) {
          this.$refs["box_" + e.prms.boxId][0].reInit(e);
        }
        this.editClosed(e.prms.boxId);
      } else {
        this.$emit("on-task-reload", e);
        this.editClosed();
      }
    },
    projectUsers() {
      this.projectEdit.render = true;
      this.$nextTick(function() {
        this.projectEdit.show = true;
      });
    },
    showMention() {
      this.projectMention.module = "task";
      this.projectMention.show = true;
    },
    // showSettings(){
    //   this.projectEdit.render = true;
    //   this.$nextTick(function() {
    //     this.projectEdit.show = true;
    //   });
    // },
    // projectUsersClosed() {
    //   this.projectEdit.show = false;
    // },
    showMembers() {
      this.projectMention.module = "members";
      this.projectMention.show = true;
    },
    // showMention(){
    //   this.mentionDialog.show= true;
    // },
    mentionAfter(e) {
      this.mentionDialog.afterData = e;
      this.taskUsersKey++;
      this.mentionDialog.show = false;
    },
    showDetail(t) {
      this.taskDialogSide.boxId = t.boxId;
      this.taskDialogSide.id = t.id;
    },
    boxReloadForce(e) {
      // console.log('boxReloadForce fired', e);
      this.init();
    },
    showDetailForce(t) {
      this.taskDialogSide.id = 0;
      this.$nextTick(() => {
        this.taskDialogSide.id = t.id;
      });
      //
    },
    changeTab(ind) {
      //console.log("changeTab fired", ind);
      this.activeTab.ind = ind;
      if (this.ind == 3) {
        this.showTransfers(this.obj.data.task);
      }
      this.$nextTick(function() {
        this.getWindowHeight();
      });
    },
    executionInit(e) {
      this.$refs.executionList.initById(e);
    },
    onReachBottom(e) {
      var container = this.$el.querySelector("#executions-outer");
      $("#executions-outer").animate({
        scrollTop: e == "bottom" ? container.scrollHeight : 0,
      });
    },
    onTaskUsers(e) {
      this.obj.data.pinnedUsers = e;
    },
    changeTaskDone() {
      request({
        api: { method: "post", url: "TaskInUser/changeIsDone" },
        data: {
          taskId: this.obj.data.task.id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.$emit("on-task-detail", this.obj.data.task);
        }
      });
    },
    userSettingsClicked(e, task) {
      if (
        confirm("Итгэлтэй байна уу. Үйлдлийг зөвшөөрснөөр буцаах боломжгүй ?")
      ) {
        this.mdlUserJSON.userId = task.userId;
        this.mdlUserJSON.taskId = task.id;

        switch (parseInt(e, 10)) {
          case 1:
            this.mdlUsernameChange = true;
            break;
          case 2:
            this.mdlUsermobileChange = true;
            break;
          case 3:
            this.mdlUsermailChange = true;
            break;
          case 4:
            this.mdlUserpassChange = true;
            break;
          case 5:
            this.mdlUserroleChange = true;
            break;
          case 6:
            this.mdlUserorgChange = true;
            break;

          case 7:
            this.mdlUserstateChange = true;
            break;

          case 8:
            this.mdlUserPinChange = true;
            break;
          // case 9:
          //   RemoveMemberShareFromThisUser({userId: this.task.userId}).then(res => {
          //     if(res!=false){
          //       this.$Message.success("Амжилттай.");
          //     }
          //   });
          //   break;

          default:
            break;
        }
      }
    },
    //Судлаачдын сан тохируулах
    projStfSendShupz(e) {},
    projStfInf(e) {
      let rv = "";
      // if()
      return rv;
    },
    cancelShow(task) {
      this.cancelProject.render = true;
      this.cancelProject.obj = task;
      this.$nextTick(function() {
        this.cancelProject.show = true;
      });
    },
    projStfAssign(task) {
      this.assignProject.render = true;
      this.assignProject.obj = task;
      this.$nextTick(function() {
        this.assignProject.show = true;
      });
    },
    projStfComplete(task) {
      this.completeProject.render = true;
      this.completeProject.obj = task;
      this.$nextTick(function() {
        this.completeProject.show = true;
      });
    },
    completeProjectDo() {
      if (
        (this.completeProject.flag == 777 ||
          this.completeProject.flag == -777) &&
        this.completeProject.desc != null &&
        this.completeProject.desc != ""
      ) {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            id: this.completeProject.obj.id,
            objectTypeId: this.completeProject.obj.objectTypeId,
            parentId: 0,
            projectId: this.completeProject.obj.projectId,
            boxId: 0,
          },
          store: this.$store,
        }).then((res3) => {
          this.handleLoading({ isLoading: false });
          if (res3 != false) {
            let _tsk3 = res3.data.task;
            _tsk3.i8 = this.completeProject.flag;
            _tsk3.f1 = this.completeProject.desc;

            this.handleLoading({ isLoading: true });
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _tsk3 },
              store: this.$store,
            }).then((res4) => {
              this.handleLoading({ isLoading: false });
              if (res4 != false) {
                this.$emit("on-row-updated", this.completeProject.obj.id);
                this.visibleChanged(false);
                Notification.info({
                  title: "Амжилттай",
                  message: `Төслийн үр дүн орууллаа`,
                  duration: 5000,
                  position: "bottom-right",
                });
              }
            });
          }
        });
      } else {
        Message({
          message: "Төлөв болон тайлбар хоосон байж болохгүй.",
          type: "warning",
        });
      }
    },
    attendanceQR(task) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _hst = this.$store.state.app.activeGroup.hostPro[0];
      // || this.$store.state.app.activeGroup.id == 9365
      if (this.$store.state.app.activeGroup.id == 9254 ) {
        _hst = _hst + "/academy";
      }

      let _qrtxt = `http://${_hst}/#/lms/qrat/${this.parentTask.id}/${task.id}`;
      //console.log('_qrtxt', _qrtxt, );
      request({
        api: { method: "POST", url: "QR/Generate" },
        data: {
          qr: _qrtxt,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.qrObj.value = "data:image/png;base64, " + res.data.base64;
          this.qrObj.task = task;
          this.qrObj.modal = true;
        }
      });
    },
    crseRpr(task) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/CourseIrtsRepair" },
        data: { taskId: task.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          Message({ message: "Амжилттай хадгаллаа.", type: "success" });
        }
      });
    },
    exportUsers(task) {
      // this.viewLogDialog.id = task.id;
      // this.viewLogDialog.show = true;
      //this.logViewingTaskId = task.id;
      //ExportTaskUsers({ id: this.task.id })
      request({
        api: { method: "get", url: "TaskInUser/ExportInheritedList" },
        params: { taskId: task.id },
        store: this.$store,
      }).then((res) => {
        this.showFile(res.data.file.id);
      });
    },
    logViews(task) {
      this.viewLogDialog.id = task.id;
      this.viewLogDialog.show = true;
      //this.logViewingTaskId = task.id;
    },
    showAttendence(e) {
      this.$emit("on-attendence", e);
    },
    examScorePlan(task){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Member/ExamScorePlane" },
        data: { id: task.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    duplicateCourse(e) {
      this.processingObj = { id: e.id, module: "duplicate" };
      this.busy = true;
      //console.log('duplicateCourse=> ', e);
    },
    duplicateCourseConfirm() {
      this.processing = true;
      request({
        api: { method: "POST", url: "v2/learn/DuplicateCourse" },
        data: { id: this.processingObj.id },
        store: this.$store,
      }).then((res) => {
        this.processing = false;
        this.busy = false;
        if (res != false) {
          this.$emit("on-duplicated", res.data);
          // this.duplicateData.course=res.data.course;
          // this.duplicateData.exams=res.data.exams;
          // this.duplicateData.modal=true;
          // console.log('DuplicateCourse=> ', res);
        }
      });
    },
    prepareExamResult() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "v5/Learn/CheckExamVersion" },
        params: { id: this.id },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          let _url = "v2/learn/ExtractExamData";
          if (res.data.isExamV5) {
            _url = "v5/learn/ExtractExamData";
          }
          this.handleLoading({ isLoading: true });
          request({
            api: { method: "GET", url: _url },
            params: { id: this.id },
            store: this.$store,
          }).then((res) => {
            this.handleLoading({ isLoading: false });
            if (res != false) {
              this.$bvToast.toast(
                res.data.count + " шалгалтын үр дүн боловсрууллаа",
                {
                  title: "Мэдэгдэл",
                  autoHideDelay: 60000,
                  appendToast: false,
                  variant: "success",
                  toaster: "b-toaster-bottom-left",
                }
              );
            }
          });
        }
      });
    },
    // prepareExamResult() {
    //   this.handleLoading({ isLoading: true });
    //   request({
    //     api: { method: "GET", url: "v2/learn/ExtractExamData" },
    //     params: { id: this.id },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.handleLoading({ isLoading: false });
    //     if (res != false) {
    //       this.$bvToast.toast(
    //         res.data.count + " шалгалтын үр дүн боловсрууллаа",
    //         {
    //           title: "Мэдэгдэл",
    //           autoHideDelay: 60000,
    //           appendToast: false,
    //           variant: "success",
    //           toaster: "b-toaster-bottom-left",
    //         }
    //       );
    //       // this.$Notice.open({
    //       //   title: "Мэдэгдэл",
    //       //   desc: res.data.count + " шалгалтын үр дүн боловсрууллаа"
    //       // });
    //     }
    //   });
    // },
    renewAllCourseCertificate() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "v2/Learn/RenewAllCourseCertificate" },
        data: { id: this.id },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        //console.log("RenewAllCourseCertificate=> ", res);
        if (res != false) {
          Notification.success({
            message: "Амжилттай",
            duration: 5000,
          });
        }
      });
    },
    lessonAnnualDataPrint(task) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        params: { id: task.id, formId: task.defaultFormId },
        api: { method: "get", url: "v2/Learn/lessonAnnualDataPrint" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        console.log("res", res);
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    printExamResult() {
      //learn/courseAnnualPrint
      //courseAnnualPrint({ id: this.id })
      request({
        api: { method: "GET", url: "learn/courseAnnualPrint" },
        params: { id: this.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    showCourseAnnual() {
      this.courseAnnualObj.courseId = this.id;
      this.$nextTick(() => {
        this.courseAnnualObj.modal = true;
      });
    },
    visibleChangedCourseAnnual(e) {
      if (!e) {
        this.courseAnnualObj.courseId = 0;
        this.courseAnnualObj.modal = false;
      }
    },
    visibleChanged(e) {
      if (!e) {
        //Object.assign(this.$data, this.$options.data());
        this.$emit("on-task-close");
      }
    },
    onShowValue(e) {
      //console.log("onShowValue fired", e);
      //TaskInUser/GetInheritedList get
      //taskId: this.taskId, page: 0, size: 5
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "taskInUser/GetInheritedList" },
        params: { taskId: this.id, page: 0, size: 20000 },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          if (
            hasOneOf(
              res.data.users.map((u) => {
                return u.userId;
              }),
              this.$store.state.user.userId
            )
          ) {
            this.showValue.obj = e;
            this.showValue.mdl = true;
          } else {
          }
        }
      });
    },

    onExamReport(e) {
      this.examChartObj.id = e;
      this.$nextTick(() => {
        this.examChartObj.show = true;
      });
    },
    onExamReportExport(e) {
      request({
        api: { method: "GET", url: "Form/GetExamFilledChartDataExport" },
        params: { examId: e },
        store: this.$store,
      }).then((res) => {
        this.showFile(res.data.file.id);
        // this.obj.questions= res.data.questions;
        // this.obj.rdy= true;
        //console.log(res);
      });
    },
    setFullTask(e) {
      this.detailSetting.leftSideHide = true;
      this.detailSetting.hideRightSidebar = e;
    },
    onFormSeting(e) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "Box/GetFormSetting" },
        params: { boxId: e.boxId, formId: e.id },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.formPayment.setting = res.data.setting;
          this.formPayment.modal = true;
        }
      });
    },
    formPaymentSubmit() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "Box/PostFormSetting" },
        data: {
          boxId: this.formPayment.setting.boxId,
          formId: this.formPayment.setting.formId,
          hasPayment: this.formPayment.setting.hasPayment,
          budget: this.formPayment.setting.budget,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.formPayment.modal = false;
        }
      });
    },
    onMenuClicked(e) {
      switch (e) {
        case "edit":
          this.editShow(this.obj.data.task);
          break;
        case "delete":
          this.deleteShow(this.obj.data.task);
          break;

        default:
          break;
      }
    },
    spAllowShinjeechRequest(e) {
      //console.log('tsk',  e);
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "auth/GetUserRoles" },
        params: {
          userId: e.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          let _roles = res.data.roles;
          //console.log("res", _roles);
          _roles.push({
            roleId: "41fcc0ed-6a2b-4eab-81eb-809769300d73",
            roleName: "stf_proj_shinjeech",
          });

          this.handleLoading({ isLoading: true });
          request({
            api: { method: "POST", url: "auth/SetUserRoles" },
            data: {
              userId: e.userId,
              roles: _roles,
            },
            store: this.$store,
          }).then((resr) => {
            this.handleLoading({ isLoading: false });
            if (resr != false) {
              //console.log("resr", resr);

              this.handleLoading({ isLoading: true });
              request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                  id: e.id,
                  objectTypeId: 567,
                  parentId: 0,
                  projectId: e.projectId,
                  boxId: 0,
                  userId: this.$store.state.user.userInfo.userId,
                },
                store: this.$store,
              }).then((res3) => {
                this.handleLoading({ isLoading: false });
                if (res3 != false) {
                  let _tsk3 = res3.data.task;
                  _tsk3.isTender = true;
                  //console.log(_tsk3, e);

                  this.handleLoading({ isLoading: true });
                  request({
                    api: { method: "POST", url: "Task/PostInherited" },
                    data: { model: _tsk3 },
                    store: this.$store,
                  }).then((res4) => {
                    this.handleLoading({ isLoading: false });
                    if (res4 != false) {
                      this.$emit("on-row-updated", e.id);
                      this.visibleChanged(false);
                      Notification.info({
                        title: "Амжилттай",
                        message: `Шинжээчээр ажиллах хүсэлтийг шийдвэрлэлээ`,
                        duration: 5000,
                        position: "bottom-right",
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
  },
  computed: {
    taskId() {
      return this.id;
    },
  },
  watch: {
    taskId(val) {
      if (val > 0) {
        this.init();
      }
    },
  },
};
</script>
<style lang="scss">
.vsble-on-mble {
  visibility: visible !important;
  transform: translateX(0px) !important;
  opacity: 1 !important;
}
.full-mdl.modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
